// DE-BASE-RULES (P4, 2026-10-30): the platform rules every DE and AG follows, served to the
// agency console and to ClawPanel, which pins the AG part into AG profiles (they have no CompanyOS
// connection). Read-only today; it becomes an operator setting later. The text is generated from
// `packages/domain-agents/src/base-rules.ts` (the same as `docs/agents/platform/base-rules.md`).
import { z } from "zod";
import { defineRoute } from "./route";

export const BaseRuleRow = z
  .object({
    key: z.string(),
    title: z.string(),
    /** `all`: every DE and AG (the AG's pinned copy); `de`: DEs only (needs a seat and a run). */
    applies_to: z.enum(["all", "de"]),
    text: z.string(),
  })
  .meta({ id: "BaseRuleRow" });

export const BaseRulesView = z
  .object({
    version: z.string(),
    rules: z.array(BaseRuleRow),
    /** The rules for DEs, one text (what checkout serves as `baseRules.text`). */
    de_text: z.string(),
    /** The rules for AGs, one text (the `all` rules). */
    ag_text: z.string(),
    /** The versioned export (frontmatter `version`), as `docs/agents/platform/base-rules.md`. */
    markdown: z.string(),
  })
  .meta({ id: "BaseRulesView" });
export type BaseRulesView = z.infer<typeof BaseRulesView>;

export const baseRulesRoutes = {
  "operator.baseRules.get": defineRoute({
    feature: "core",
    tag: "operator",
    access: "operator",
    id: "operator.baseRules.get",
    method: "get",
    path: "/v1/operator/base-rules",
    summary: "The platform base rules every DE and AG follows, with the AG copy and the export",
    response: { status: 200, schema: BaseRulesView },
    errors: [],
    emits: [],
  }),
};
